import { useQuery } from '@tanstack/react-query';
import { KnowledgeArticleListItemDto } from 'src/api/FiretrolApiClient';
import { knowledgeArticleApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export type { KnowledgeArticleListItemDto };

export interface IKnowledgeArticleFilter {
  search?: string;
  officeId?: number;
  status?: string;
  page: number;
  pageSize: number;
}

/** placeholderData keeps prior rows on screen during page/filter loads (v5's keepPreviousData). */
export function useKnowledgeArticles(filter: IKnowledgeArticleFilter) {
  return useQuery({
    queryKey: queryKeys.knowledgeArticles.list(filter),
    queryFn: ({ signal }) =>
      knowledgeArticleApiClient.list(
        filter.search || undefined,
        filter.officeId,
        filter.status,
        filter.page,
        filter.pageSize,
        toCancelToken(signal),
      ),
    placeholderData: (previousData) => previousData,
  });
}
